<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1100px"
      center
      destroy-on-close	
      >
      <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="100px">
       <el-form-item label="通知标题：" prop="title">
          <el-input style="width: 400px;" v-model="formData.title" placeholder="请输入通知标题" :maxlength='30' show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="通知内容：" prop="content" label-width="100px">
          <Editor width='880px' scene_name='activity' v-model='formData.content'></Editor>
        </el-form-item>
        <el-form-item label="附件：" prop="attach">
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="true"
            :on-change="handleAvatarSuccess"
            :limit='5'
            multiple
            :auto-upload="false"
            :on-error="uploadError"
            :file-list="fileList"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            >
            <el-button size="small" type="primary" icon="el-icon-plus">上传附件</el-button>
            <div style="color: #999;">支持pdf，doc，docx，jpg，png等格式文件上传，文件大小10MB</div>
          </el-upload>
          <template v-if="formData.attach && formData.attach.length">
            <div class="file flex-fs" v-for="(file,f) in formData.attach" :key="f">
              <i class="el-icon-document"></i>
              <div class="flex-1">{{ file | fileName }}</div>
              <i class="el-icon-close" @click="formData.attach.splice(f, 1)"></i>
            </div>
          </template>
        </el-form-item>
        
        <el-form-item label="定时推送：" prop="is_timer">
          <el-switch
            active-text='开'
            inactive-text='关'
            :active-value='1'
            :inactive-value	='0'
            v-model="formData.is_timer"
           >
          </el-switch>
        </el-form-item>
        
        <el-form-item label="推送时间：" prop="timing_time" v-if="formData.is_timer == 1">
          <el-date-picker
            v-model="formData.timing_time"
            type="datetime"
            format='yyyy-MM-dd HH:mm'
            value-format='yyyy-MM-dd HH:mm'
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="推送渠道：" prop="publish_type">
          <el-checkbox-group v-model="formData.publish_type">
            <el-checkbox label="internal">{{ 'internal' | publish_type }}</el-checkbox>
            <el-checkbox label="push">{{ 'push' | publish_type }}</el-checkbox>
            <!-- <el-checkbox label="message">短信推送</el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        
        <el-form-item label="推送用户：" prop="notice_scope">
          <div class="flex-box user-box" @click="showPickUser">
            <div v-if="formData.notice_scope && formData.notice_scope.length" style="margin-bottom: -6px;">
              <el-tag v-for='(item,i) in notice_scope_set' :key="i">{{ item.user_name || '--' }}</el-tag>
            </div>
            <div v-else style="color: #C0C4CC;">请选择推送用户</div>
            <i class="el-icon-search" style="margin-top: 12px;"></i>
          </div>
          <!-- <el-input type="hidden" v-model="formData.notice_scope" placeholder="请选择推送用户"></el-input> -->
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button @click="save" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <pickUser ref="pick" @change='getPickUser'></pickUser>
   </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  import Editor from '@/components/Editor';
  import pickUser from './pickUser'
  export default {
    components:{ Editor, pickUser },
    data() {
      return {
        checkbox: [],
        dialogVisible: false,
        title: '',
        formData: { //弹窗 内容
          title: '',
          is_timer: 0,
          timing_time: '',
          publish_type: [],
          attach: [],
          content: '',
          notice_scope: ''
        },
        types: [
          {label: '社工服务', value: 'community'},
          {label: '志愿风采', value: 'volunteer'}
        ],
        rules: {
          title: [{
            required: true,
            message: '请输入通知标题',  
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }],
          attach: [{
            required: false,
            message: '请上传附件',
            trigger: 'change'
          }],
          is_timer: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: '请输入通知内容',
            trigger: 'blur'
          }],
          timing_time: [{
            required: true,
            message: '请选择推送时间',
            trigger: 'blur'
          }],
          publish_type: [{
            required: true,
            message: '请选择推送方式',
            trigger: 'change'
          }],
          notice_scope: [{
            required: true,
            message: '请选择推送范围',
            trigger: 'change'
          }],
        },
        fileList: []
      }
    },
    computed:{
      notice_scope_set(){
        let map = new Map();
        return this.formData.notice_scope.filter(item => !map.has(item['user_id']) && map.set(item['user_id'],1))
      }
    },
    methods: {
      show(row){
        if(row && row.id){
          this.title = '编辑通知'
          userInfoAPI.detailNotice(row.id).then(({ data })=>{
            if (data.code == 0) {
              if(typeof data.data.attach == 'string') data.data.attach = JSON.parse(data.data.attach)
              if(typeof data.data.publish_type == 'string') data.data.publish_type = JSON.parse(data.data.publish_type)
              this.formData = {
                id: data.data.id,
                title: data.data.title,
                is_timer: data.data.is_timer,
                timing_time: data.data.timing_time,
                publish_type: data.data.publish_type || [],
                attach: data.data.attach || [],
                content: data.data.content,
                notice_scope: data.data.notice_scope
              }
              this.dialogVisible = true
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        }else{
          this.title = '新增通知'
          this.formData = {
            title: '',
            is_timer: 0,
            timing_time: '',
            publish_type: [],
            attach: [],
            content: '',
            notice_scope: []
          }
          this.dialogVisible = true
        }
      },
      showPickUser(){
        if(!this.formData.publish_type.length){
          this.$message.warning('请先选择推送渠道')
        }else{
          this.$refs.pick.show(this.formData.notice_scope, this.formData.publish_type)
        }
      },
      getPickUser(list){
        this.formData.notice_scope = list
        this.$refs.added.validateField('notice_scope')
      },
      save(formList){
        let that = this;
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(that.fileList.length){
              let files = that.fileList.map(r=>{
                return r.raw
              })
              await upload(files, 'notice').then((urls)=>{
                that.formData.attach = [...that.formData.attach, ...urls]
                that.fileList = []
              })
            }
            let formData = JSON.parse(JSON.stringify(that.formData))
            if(formData.is_timer == 0) delete formData.timing_time
            if(that.formData.id){
              userInfoAPI.updateNotice(formData).then(({ data })=>{
                if (data.code == 0) {
                  that.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  that.dialogVisible = false
                  that.$emit('success')
                } else {
                  that.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }else{
              userInfoAPI.addNotice(formData).then(({ data })=>{
                if (data.code == 0) {
                  that.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  that.dialogVisible = false
                  that.$emit('success')
                } else {
                  that.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }
          }
        })
       
      },
      uploadError(err, file, fileList) {
        this.$message({
            message: "上传出错，请重试！",
            type: "error",
            center: true
          });
        },
      handleRemove(file, fileList) {
        this.fileList = this.fileList.filter(i=>i.uid !== file.uid)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`限制选择 5 个文件，当前共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleAvatarSuccess(file, fileList){
        if((this.fileList.length + this.formData.attach.length) > 5){
          this.$message.warning(`限制选择 5 个文件，当前共选择了 ${this.fileList.length + this.formData.attach.length} 个文件`);
          this.fileList = fileList.filter(i=>i.uid !== file.uid)
          return
        }
        if(file.raw.type.indexOf('image') > -1){
          const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png' || file.raw.type === 'image/jpg'
          const isLt5M = file.raw.size / 1024 / 1024 < 5
          if (!isIMAGE) {
            this.$message({
              showClose: true,
              message: '请选择 jpeg、jpg、png 格式的图片',
              type: 'warning'
            })
            this.fileList = fileList.filter(i=>i.uid !== file.uid)
            return false
          }
          if (!isLt5M) {
            this.$message({
              showClose: true,
              message: '图片大小不能超过 5MB',
              type: 'warning'
            })
            this.fileList = fileList.filter(i=>i.uid !== file.uid)
            return false
          }
        }
        else if(file.raw.type.indexOf('application') > -1){
          const isFile = file.raw.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.raw.type === 'application/msword' || file.raw.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file.raw.type === 'application/vnd.ms-powerpoint' || file.raw.type === 'application/pdf'
          const isLt10M = file.raw.size / 1024 / 1024 < 10
          if (!isFile) {
            this.$message({
              showClose: true,
              message: '请选择 pdf，doc，docx 格式的文件',
              type: 'warning'
            })
            this.fileList = fileList.filter(i=>i.uid !== file.uid)
            return false
          }
          if (!isLt10M) {
            this.$message({
              showClose: true,
              message: '图片大小不能超过 10MB',
              type: 'warning'
            })
            this.fileList = fileList.filter(i=>i.uid !== file.uid)
            return false
          }
        }else{
          this.$message({
            showClose: true,
            message: '该格式不支持',
            type: 'warning'
          })
          this.fileList = fileList.filter(i=>i.uid !== file.uid)
          return
        }
        this.fileList.push(file)
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/{
    .el-upload {
      text-align: left;
    }
  }
  .user-box{
    width: 500px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding:0 6px;
    min-height: 36px;
    justify-content: space-between;
    max-height: 400px;
    overflow-y: auto;
  }
  .el-tag{
    margin: 0 10px 10px 0;
  }
  .file{
    padding: 2px 4px;
    cursor: pointer;
    i{
      font-size: 12px;
      color: #909399;
    }
    .el-icon-close{
      display: none;
      font-size: 14px;
      transform: scale(0.8);
    }
    .el-icon-document{
      margin-right: 6px;
    }
    div{
      font-size: 11px;
    }
    &:hover{
      background-color: #FAF9FB;
      .el-icon-close{
        display: block;
      }
    }
  }
</style>